module.exports = __webpack_public_path__ + "img/slide14.3bbc965d.png";